import MarketingShell from '../components/MarketingShell';

export default function Company() {
  return (
    <MarketingShell>
      <section className="mk-section">
        <div className="mk-split">
          <div className="mk-info-card">
            <h3>Company</h3>
            <p>We build practical software for programme leaders who need better oversight, faster decisions, and better delivery outcomes — across any transformation, any platform.</p>
          </div>
          <div className="mk-info-card">
            <h3>Contact</h3>
            <p>Product questions, demos, and enterprise onboarding.</p>
            <p><a href="mailto:hello@transformax.app">hello@transformax.app</a></p>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
